import { render, staticRenderFns } from "./edit-shape-group.vue?vue&type=template&id=35c974a6&scoped=true"
import script from "./edit-shape-group.vue?vue&type=script&lang=js"
export * from "./edit-shape-group.vue?vue&type=script&lang=js"
import style0 from "./edit-shape-group.vue?vue&type=style&index=0&id=35c974a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c974a6",
  null
  
)

export default component.exports